import { defineComponent, useSlots, ref, computed, watch, onMounted, createElementBlock, openBlock, normalizeClass, createElementVNode, createCommentVNode, createVNode, renderSlot } from 'vue';
import { useWindowScroll } from './basler-components.es419.js';
import _sfc_main$1 from './basler-components.es157.js';
/* empty css                        */
import _sfc_main$2 from './basler-components.es161.js';
/* empty css                        */
import { useSlotContent } from './basler-components.es425.js';

const _hoisted_1 = { class: "distraction-free-header__main" };
const _hoisted_2 = { class: "distraction-free-header__outer" };
const _hoisted_3 = { class: "distraction-free-header__inner" };
const _hoisted_4 = {
  key: 0,
  class: "distraction-free-header__demo-banner"
};
const _hoisted_5 = { class: "distraction-free-header__demo-banner-content" };
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = { class: "distraction-free-header__user-action-bar" };
const _hoisted_9 = {
  key: 0,
  class: "distraction-free-header__secondary-bar"
};
const _hoisted_10 = { class: "distraction-free-header__secondary-bar__inner" };
const _hoisted_11 = { class: "distraction-free-header__secondary-bar__header" };
const _hoisted_12 = {
  key: 0,
  class: "distraction-free-header__content"
};
const _hoisted_13 = {
  key: 1,
  class: "distraction-free-header__actions"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "DistractionFreeHeader",
  props: {
    logoLink: {},
    logoTagName: {},
    logoText: {},
    userActionItems: {},
    showDemoBanner: { type: Boolean },
    demoBannerText: {},
    demoBannerTextLong: {}
  },
  emits: ["navigate"],
  setup(__props) {
    const { y: scrollPositionY } = useWindowScroll();
    const slots = useSlots();
    const { hasSlotContent } = useSlotContent();
    const isSticky = ref(false);
    const hasActionsSlotContent = computed(() => {
      return hasSlotContent(slots.actions);
    });
    const hasSecondaryBarSlotContent = computed(() => {
      return hasSlotContent(slots["secondary-bar"]);
    });
    watch(scrollPositionY, (newVal) => {
      isSticky.value = newVal > 0;
    });
    onMounted(() => {
      isSticky.value = scrollPositionY.value > 0;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("header", {
        class: normalizeClass([
          "distraction-free-header",
          { "distraction-free-header--is-sticky": isSticky.value },
          { "distraction-free-header--has-demo-banner": _ctx.showDemoBanner },
          "theme-dark"
        ])
      }, [
        createElementVNode("div", _hoisted_1, [
          createElementVNode("div", _hoisted_2, [
            createElementVNode("div", _hoisted_3, [
              createVNode(_sfc_main$1, {
                "logo-link": _ctx.logoLink,
                "tag-name": _ctx.logoTagName,
                "logo-text": _ctx.logoText
              }, null, 8, ["logo-link", "tag-name", "logo-text"]),
              _ctx.showDemoBanner ? (openBlock(), createElementBlock("div", _hoisted_4, [
                createElementVNode("div", _hoisted_5, [
                  createElementVNode("span", {
                    class: "distraction-free-header__demo-banner-content-mobile",
                    innerHTML: _ctx.demoBannerText
                  }, null, 8, _hoisted_6),
                  createElementVNode("span", {
                    class: "distraction-free-header__demo-banner-content-desktop",
                    innerHTML: _ctx.demoBannerTextLong
                  }, null, 8, _hoisted_7)
                ])
              ])) : createCommentVNode("", true),
              createElementVNode("div", _hoisted_8, [
                createVNode(_sfc_main$2, {
                  items: _ctx.userActionItems,
                  "aria-label": "User actions"
                }, null, 8, ["items"])
              ])
            ])
          ]),
          hasSecondaryBarSlotContent.value || hasActionsSlotContent.value ? (openBlock(), createElementBlock("div", _hoisted_9, [
            createElementVNode("div", _hoisted_10, [
              createElementVNode("div", _hoisted_11, [
                hasSecondaryBarSlotContent.value ? (openBlock(), createElementBlock("div", _hoisted_12, [
                  renderSlot(_ctx.$slots, "secondary-bar")
                ])) : createCommentVNode("", true),
                hasActionsSlotContent.value ? (openBlock(), createElementBlock("div", _hoisted_13, [
                  renderSlot(_ctx.$slots, "actions")
                ])) : createCommentVNode("", true)
              ])
            ])
          ])) : createCommentVNode("", true)
        ])
      ], 2);
    };
  }
});

export { _sfc_main as default };
